import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DataSourceWrapper from '../DataSourceWrapper';
import { StudyListPage, ViewerLayoutWrap, PDFWrap, PdfEdit } from '@ohif/ui';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import userSvg from './images/user.svg';
import { useAppConfig } from '@state';

import './MainWrap.less';

const MobileMainWrap: React.FC = () => {
  const [activeTab, setActiveTab] = useState('worklist'); // 控制当前活动的 Tab
  const [iframeUrl, setIframeUrl] = useState<any>('');
  const [pdfIframeUrl, setPdfIframeUrl] = useState<any>('');
  const [appConfig] = useAppConfig();
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Link
          to="/"
          onClick={() => sessionStorage.removeItem('user')}
        >
          <span>退出</span>
        </Link>
      ),
    },
    {
      key: '2',
      label: (
        <div onClick={() => changeThumbnailLocation()}>
          <span>更改缩略图位置</span>
        </div>
      ),
    },
  ];

  const changeThumbnailLocation = () => {
    const newThumbnailLocation =
      localStorage.getItem('thumbnailLocation') === 'top' ? 'right' : 'top';
    localStorage.setItem('thumbnailLocation', newThumbnailLocation);
    localStorage.setItem('isUserSet', 'true');
  };

  const handleTabChange = (
    key: string,
    url: string,
    isDoubleClick?: boolean,
    studyInstanceUid?: string
  ) => {
    setActiveTab(key);
    if (key === 'viewer') {
      if (url) {
        setIframeUrl(url);
        if (isDoubleClick) {
          setPdfIframeUrl(
            '/ncpacsservice/reportPicServlet?reg_key=' +
            studyInstanceUid +
            '&output=pdfbyte#view=Fit'
          );
        }
      }
    } else if (key === 'pdf') {
      if (url) {
        setPdfIframeUrl(url);
      }
    }
  };
  return (
    <div className="mainwrap-page" style={{background:'#fff'}}>
      <div>
        <div
          style={{
            display: activeTab === 'worklist' ? 'block' : 'none',
            height: activeTab === 'worklist' ? '100vh' : 0,
          }}
        >
          <StudyListPage handleTabChange={handleTabChange} flag='mobile'/>
        </div>
      </div>
    </div>
  );
};

export default MobileMainWrap;
